import { getToken, clearAllStorage } from "./TokenService";

const fetchWrapper = async (
  url,
  options = {},
  navigate,
  rawResponse = false
) => {
  const token = getToken();
  const headers = {
    ...options.headers,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, { ...options, headers });

    if (!response.ok) {
      if (response.status === 401) {
        clearAllStorage();
        navigate("/auth/login");
        return;
      }

      const errorData = await response.json();
      const error = new Error(errorData.message || "Something went wrong");
      error.response = errorData;
      throw error;
    }

    if (rawResponse) {
      return response;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON response
    }

    // If the response is not JSON, return the response as is
    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error; // Re-throw the error for handling in the calling function
  }
};

export default fetchWrapper;
